import { gql } from '@apollo/client';
import { BriefUserInfoFieldsFragment } from './fragments';

export const SEARCH_USERS_QUERY = gql`
  query SearchUsers(
    $term: String
    $includes: [ID!]!
    $pagination: Pagination!
    $userStates: [UserState!]!
  ) {
    users(
      term: $term
      includes: $includes
      pagination: $pagination
      userStates: $userStates
    ) {
      entities {
        ...BriefUserInfoFields
      }
    }
  }
  ${BriefUserInfoFieldsFragment}
`;
